import type { CSSProperties } from 'react';

export type AvatarSize = 'sm' | 'md' | 'lg';

export type AvatarProps = {
  initials?: string | null;
  color?: string | null;
  size?: AvatarSize;
  fallback?: string;
  style?: CSSProperties;
};

/**
 * Small initials-based avatar. The prototype took a `staff` object; here we
 * take just the displayable pieces so any caller can use it.
 */
export function Avatar({ initials, color, size = 'md', fallback, style }: AvatarProps) {
  if (!initials) {
    return (
      <div className={`avatar avatar-${size} avatar-na`} style={style}>
        {fallback ?? 'N/A'}
      </div>
    );
  }
  return (
    <div
      className={`avatar avatar-${size}`}
      style={{ background: color ?? 'var(--green-600)', ...style }}
    >
      {initials}
    </div>
  );
}

/** Build two-letter initials from a full name, e.g. "Alex Kim" → "AK". */
export function initialsFromName(fullName: string | null | undefined): string {
  if (!fullName) return '';
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
